export default {
  name: 'WishItem',
  props: {
    wishConfig: Object,
    wishType: String
  },
  computed: {
    wishItemClassList() {
      return ['wish-item', this.wishConfig.isCur ? 'wish-item_current' : ''];
    },
    imageStyleObj() {
      return {
        backgroundImage: `url(${this.wishConfig.imageUrl || ''})`
      };
    },
    isSmallFontSize() {
      return !!(this.wishConfig && this.wishConfig.title && this.wishConfig.title.length > 8);
    }
  }
};
